import BaseAPI from "api/BaseAPI";

class CompanyUser extends BaseAPI {
	
	async get(companyid, page) {
			let response =  await this.init().get("/account/company/"+ companyid +"/user");
			return response.data;
	}

	async getUserById(companyid, id) {
			let response =  await this.init().get("/account/company/"+ companyid +"/user/"+id);
			return response.data;
	}

	async removeUserFromCompany(companyid, id) {
			let response =  await this.init().delete("/account/company/"+ companyid +"/user/"+id);
			return response.data;
	}

	create(companyid, params) {
		try {
			var t = this.init().post("/account/company/"+ companyid+"/user", params);
			return t;
		} catch(error) {
			console.log( error );
		}
		return false;
	}
		
	update(companyid, params) {
		try {
			var t = this.init().put("/account/company/"+ companyid+"/user/"+params.id, params);
			return t;
		} catch(error) {
			console.log( error );
		}
		return false;
	}
	
}


export default new CompanyUser();